import { lazy } from "react"; //insures components are loaded correctly as actual React components rather than Promises.

const routes =[
    {
        path: "/",
        name: "Employee Manager",
        component: lazy(() => import("./employeeManager/EmployeeManager"))
      },
      {
        path: "/login",
        name: "Login",
        component: lazy(() => import("./LoginComponent"))
      }
];

export default routes;
